import React from 'react';
import styled from 'styled-components';
import Title from '../Components/Title';
import { InnerLayout } from '../styles/Layouts';
import Particle from './Particle';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import react_icon from '../img/lp/react.png';
import html_icon from '../img/lp/html5.png';
import css_icon from '../img/lp/css3.png';
import js_icon from '../img/lp/js.png';
import php_icon from '../img/lp/php.png';
import sass_icon from '../img/lp/sass.png';
import nodejs_icon from '../img/lp/nodejs.png';
import materialui_icon from '../img/lp/materialui.png';
import bootstrap_icon from '../img/lp/bootstrap.png';
import java_icon from '../img/lp/java.png';
import outsystems_icon from '../img/lp/outsystems.png';
import firebase_icon from '../img/lp/firebase.png';
import github_icon from '../img/lp/github.png';
import vscode_icon from '../img/lp/vscode.png';
import figma_icon from '../img/lp/figma.png';
import trello_icon from '../img/lp/trello.png';
import slack_icon from '../img/lp/slack.png';
import scrum_icon from '../img/lp/scrum.png';
import git_icon from '../img/lp/git.png';
import netlify_icon from '../img/lp/netlify.png';

function Skills() {
  const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
    },
    paper: {
      padding: theme.spacing(1),
      textAlign: 'center',
      color: theme.palette.text.secondary,
      borderRadius: '50%',
      border: '1px solid var(--primary-color)',
      width: '150px',
      height: '150px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
    },
  }));

  const classes = useStyles();

  function FirstRow() {
    return (
      <React.Fragment>
        <Grid item xs={2}>
          <Paper className={classes.paper}>
            <img src={react_icon} alt="" />
          </Paper>
        </Grid>
        <Grid item xs={2}>
          <Paper className={classes.paper}>
            <img src={html_icon} alt="" />
          </Paper>
        </Grid>
        <Grid item xs={2}>
          <Paper className={classes.paper}>
            <img src={css_icon} alt="" />
          </Paper>
        </Grid>
        <Grid item xs={2}>
          <Paper className={classes.paper}>
            <img src={js_icon} alt="" />
          </Paper>
        </Grid>
        <Grid item xs={2}>
          <Paper className={classes.paper}>
            <img src={php_icon} alt="" />
          </Paper>
        </Grid>
      </React.Fragment>
    );
  }

  function SecondRow() {
    return (
      <React.Fragment>
        <Grid item xs={2}>
          <Paper className={classes.paper}>
            <img src={sass_icon} alt="" />
          </Paper>
        </Grid>
        <Grid item xs={2}>
          <Paper className={classes.paper}>
            <img src={nodejs_icon} alt="" />
          </Paper>
        </Grid>
        <Grid item xs={2}>
          <Paper className={classes.paper}>
            <img src={materialui_icon} alt="" />
          </Paper>
        </Grid>
        <Grid item xs={2}>
          <Paper className={classes.paper}>
            <img src={bootstrap_icon} alt="" />
          </Paper>
        </Grid>
        <Grid item xs={2}>
          <Paper className={classes.paper}>
            <img src={java_icon} alt="" />
          </Paper>
        </Grid>
      </React.Fragment>
    );
  }
  function ThirdRow() {
    return (
      <React.Fragment>
        <Grid item xs={2}>
          <Paper className={classes.paper}>
            <img src={outsystems_icon} alt="" />
          </Paper>
        </Grid>
        <Grid item xs={2}>
          <Paper className={classes.paper}>
            <img src={firebase_icon} alt="" />
          </Paper>
        </Grid>
        <Grid item xs={2}>
          <Paper className={classes.paper}>
            <img src={github_icon} alt="" />
          </Paper>
        </Grid>
        <Grid item xs={2}>
          <Paper className={classes.paper}>
            <img src={vscode_icon} alt="" />
          </Paper>
        </Grid>
        <Grid item xs={2}>
          <Paper className={classes.paper}>
            <img src={figma_icon} alt="" />
          </Paper>
        </Grid>
      </React.Fragment>
    );
  }
  function FourthRow() {
    return (
      <React.Fragment>
        <Grid item xs={2}>
          <Paper className={classes.paper}>
            <img src={trello_icon} alt="" />
          </Paper>
        </Grid>
        <Grid item xs={2}>
          <Paper className={classes.paper}>
            <img src={slack_icon} alt="" />
          </Paper>
        </Grid>
        <Grid item xs={2}>
          <Paper className={classes.paper}>
            <img src={scrum_icon} alt="" />
          </Paper>
        </Grid>
        <Grid item xs={2}>
          <Paper className={classes.paper}>
            <img src={git_icon} alt="" />
          </Paper>
        </Grid>
        <Grid item xs={2}>
          <Paper className={classes.paper}>
            <img src={netlify_icon} alt="" />
          </Paper>
        </Grid>
      </React.Fragment>
    );
  }
  return (
    <SkillsStyled>
      <Title title={'Skills'} span={'Skills'} />
      <InnerLayout>
        <div className="skills">
          <Grid container spacing={1}>
            <Grid
              container
              item
              xs={12}
              spacing={3}
              style={{ display: 'flex', justifyContent: 'center', alignContent: 'center', paddingBottom: '2rem' }}
            >
              <FirstRow />
            </Grid>
            <Grid
              container
              item
              xs={12}
              spacing={3}
              style={{ display: 'flex', justifyContent: 'center', alignContent: 'center', paddingBottom: '2rem' }}
            >
              <SecondRow />
            </Grid>
            <Grid
              container
              item
              xs={12}
              spacing={3}
              style={{ display: 'flex', justifyContent: 'center', alignContent: 'center', paddingBottom: '2rem' }}
            >
              <ThirdRow />
            </Grid>
            <Grid
              container
              item
              xs={12}
              spacing={3}
              style={{ display: 'flex', justifyContent: 'center', alignContent: 'center', paddingBottom: '2rem' }}
            >
              <FourthRow />
            </Grid>
          </Grid>

          <Particle />
        </div>
      </InnerLayout>
    </SkillsStyled>
  );
}

const SkillsStyled = styled.div`
  img {
    height: 100px;
    width: 100px;
  }
`;

export default Skills;
